import React from 'react'
import { Link } from 'react-router-dom'

const Error = () => {
  return (
    <div style={{ 'margin-left': '100px' }}>
      <h1>This page does not exist.</h1>
      <Link to='/'>Go back to home</Link>
    </div>
  )
}

export default Error
